import { ReactNode, useEffect } from 'react';
import { Theme } from '@cmctechnology/webinvest-constants';
import { useFrontendContext } from '@cmctechnology/webinvest-store-frontend';

interface IThemeOverrideProps {
  themeOverride: Theme;
  children: ReactNode;
}

export const ThemeOverride: React.FC<IThemeOverrideProps> = ({ themeOverride, children }) => {
  const { theme, setTheme } = useFrontendContext();

  useEffect(() => {
    /* istanbul ignore else*/
    if (themeOverride && theme !== themeOverride) {
      setTheme(themeOverride as Theme);
    }
  }, [themeOverride, theme]);

  return <>{children}</>;
};
